'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDark;

var _helpers = require('./helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDark(color) {
  if (_helpers2.default._isShorthand(color)) {
    color = _helpers2.default._expand(color);
  }

  if (_helpers2.default._isNamedColor(color)) {
    color = _helpers2.default._color2hex(color);
  }

  var _helpers$_hex2rgb = _helpers2.default._hex2rgb(color),
      r = _helpers$_hex2rgb.r,
      g = _helpers$_hex2rgb.g,
      b = _helpers$_hex2rgb.b;

  var colorArray = [r / 255, g / 255, b / 255].map(function (v) {
    if (v <= 0.03928) {
      return v / 12.92;
    }

    return Math.pow((v + 0.055) / 1.055, 2.4);
  });

  var luminance = 0.2126 * colorArray[0] + 0.7152 * colorArray[1] + 0.0722 * colorArray[2];

  return luminance <= 0.179;
}